import { MonitoringQueries } from '@/modules/Service/types'
import dayjs from 'dayjs'
import { t } from 'i18next'
import React from 'react'
import { DateRangePicker, Select, Typogaphy } from 'vnetwork-ui'

const AnalyticRangeOptions = [
    { value: '7d', label: t('7d') },
    { value: '30d', label: t('30d') },
    { value: 'this-month', label: t('this-month') },
    { value: 'last-month', label: t('last-month') },
    { value: 'customize-range', label: t('customize-range') },
]

interface HeaderProps {
    analyticQueries: MonitoringQueries
    setAnalyticQueries: React.Dispatch<React.SetStateAction<MonitoringQueries>>
}
const Header: React.FC<HeaderProps> = ({
    analyticQueries,
    setAnalyticQueries,
}) => {
    const handleRangeChange = (value: string) => {
        const today = dayjs()

        if (value === 'customize-range') {
            setAnalyticQueries((prev) => ({
                ...prev,
                range: value,
            }))
            return
        }

        let gte = today
        let lte = today

        switch (value) {
            case '7d':
                gte = today.subtract(6, 'day').startOf('day')
                lte = today.endOf('day')
                break
            case '30d':
                gte = today.subtract(29, 'day').startOf('day')
                lte = today.endOf('day')
                break
            case 'this-month':
                gte = today.startOf('month')
                lte = today.endOf('month')
                break
            case 'last-month':
                gte = today.subtract(1, 'month').startOf('month')
                lte = today.subtract(1, 'month').endOf('month')
                break
        }

        setAnalyticQueries({
            range: value,
            gte: gte.format('YYYY-MM-DD'),
            lte: lte.format('YYYY-MM-DD'),
        })
    }

    return (
        <div className="flex justify-end gap-2 bg-white rounded-[8px] p-4 col-span-5 half-col-print my-2">
            <div className="flex items-center gap-2">
                <Typogaphy className="text-sm text-gray-500 ">
                    {t('services.time-range')}
                </Typogaphy>
                <div className="min-w-[250px]">
                    <Select
                        allowClear={false}
                        options={AnalyticRangeOptions}
                        value={analyticQueries?.range}
                        onChange={(value) => handleRangeChange(value as string)}
                    />
                </div>
            </div>
            {analyticQueries?.range === 'customize-range' && (
                <div className="min-w-[250px]">
                    <DateRangePicker
                        values={[
                            dayjs(analyticQueries?.gte),
                            dayjs(analyticQueries.lte),
                        ]}
                        onChange={(newValues) => {
                            if (!newValues[0] || !newValues[1]) return
                            setAnalyticQueries({
                                ...analyticQueries,
                                gte: newValues[0]?.format('YYYY-MM-DD'),
                                lte: newValues[1]?.format('YYYY-MM-DD'),
                            })
                        }}
                    />
                </div>
            )}
        </div>
    )
}

export default Header
